import React from 'react';
import { SingleCommonType } from '../../types';
import { aigcPlaceholder } from '../../constants/placeholder';
import CommonSingleSelect from '../../components/CommonSingleSelect';
import { AIGC_OPTIONS } from '../../constants/aigc';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function AigcSelect(props: SingleCommonType) {
  return (
    <CommonSingleSelect
      {...props}
      returnKey="aigc"
      dealwithReturnValue={(value) => Number(value)}
      singlePlaceholder={aigcPlaceholder}
      options={AIGC_OPTIONS}
      pointKey={FilterButtonPoint.aigc}
      initValue="0"
    />
  );
}
